module.exports = __webpack_public_path__ + "img/ingredienten-havermoutkoekjes-met-dadels-en-abrikozen.f2eaaa2a.jpeg";